<p>
  pricing-categories works!
</p>
